<template lang="pug">
div
  .card.my-2.page-break
    .card-header
      .h5 {{ labelTotal }}
    .card-body.text-small
      table.table
        thead
          tr
            th {{ labelItems }}
            th.text-right Quantidade
            th.text-right Valor total
        tbody
          tr(v-for="(coluna, index) in report.colunas")
            td.text-small
              | {{ coluna }}
              small.ml-2.label-rounded.label(v-for="tag in tags(coluna)" :class="mapTagClass[tag]") {{ tag }}
            td.text-right {{ totais[index].q || 0 }}
            td.text-right {{ totais[index].valor_total || 0 | currency('R$ ') }}
          tr
            td.text-bold Total
            td.text-bold.text-right {{ somarTotal(totais).q }}
            td.text-bold.text-right {{ somarTotal(totais).valor_total | currency('R$ ') }}
  .card.my-2.page-break(v-for="(item, key) in report.data")
    .card-header
      .h5 {{ key }}
    .card-body.text-small
      table.table
        thead
          tr
            th {{ labelItems }}
            th.text-right Quantidade
            th.text-right Valor total
        tbody
          tr(v-for="coluna in report.colunas")
            td.text-small
              | {{ coluna }}
              small.ml-2.label-rounded.label(v-for="tag in tags(coluna)" :class="mapTagClass[tag]") {{ tag }}
            td.text-right {{ item[coluna].q || 0 }}
            td.text-right {{ item[coluna].valor_total || 0 | currency('R$ ') }}
          tr
            td.text-bold Sub Total
            td.text-bold.text-right {{ somarTotal(item).q }}
            td.text-bold.text-right {{ somarTotal(item).valor_total | currency('R$ ') }}
</template>

<script>
import { deepKey } from "paliari-js-utils"

export default {
  props: {
    report: { type: Object, required: true },
    labelItems: { type: String, required: true },
    labelTotal: { type: String, default: "Total" },
  },

  computed: {
    mapTagClass() {
      return {
        sábado: "label-warning",
        domingo: "label-error",
        feriado: "label-primary",
      }
    },
    totais() {
      if (!deepKey(this.report, "data") || !deepKey(this.report, "colunas")) {
        return []
      }
      const soma = {}

      Object.values(this.report.colunas).forEach(
        coluna => (soma[coluna] = { q: 0, valor_total: 0 }),
      )
      Object.values(this.report.data).forEach(data => {
        Object.keys(data).forEach(coluna => ({
          q: (soma[coluna].q += data[coluna].q),
          valor_total: (soma[coluna].valor_total += data[coluna].valor_total),
        }))
      })
      return Object.values(soma)
    },
  },
  methods: {
    tags(coluna) {
      if (!this.report || !this.report.tags) return []
      return this.report.tags[coluna] || []
    },
    somarTotal(item) {
      const items = Object.values(item || {})

      return items.reduce(
        (acc, item) => {
          acc.q += Number(item.q || 0)
          acc.valor_total += Number(item.valor_total || 0)
          return acc
        },
        { q: 0, valor_total: 0 },
      )
    },
  },
}
</script>
